import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'
import styled, { css } from 'styled-components'
import Transition from '../../transition';

import { MetaTags, Header, Cart, Footer, SignupForm } from '../'
import { media } from '../../styles/utils';

const Layout = ({ children, meta, ...props }) => {
	return (
		<>
			<MetaTags
				{...meta}
			/>

			<Cart />

			<Wrapper>
				<Transition>
					{children}
				</Transition>
			</Wrapper>

			<SignupForm
				noBorderTop={props.noBorderSignup}
			/>

			<Footer/>
		</>
	)
}

const Wrapper = styled.div`
	width: 100%;
	min-height: 100vh;
	box-sizing: border-box;
	overflow-x: hidden;
`

export default Layout
